import type { MenuItem } from '@/shared/types';

export const resolveAccessibleActiveView = (
  activeView: string,
  menuItems: MenuItem[],
): string | null => {
  if (menuItems.length === 0) {
    return null;
  }

  if (menuItems.some((item) => item.view === activeView)) {
    return activeView;
  }

  return menuItems[0].view;
};
